// extracted by mini-css-extract-plugin
module.exports = {"content":"information_content__CpExt","cardDark":"information_cardDark__alzj7"};